import { render, staticRenderFns } from "./agePieChart.vue?vue&type=template&id=2e269bfb&scoped=true"
import script from "./agePieChart.vue?vue&type=script&lang=js"
export * from "./agePieChart.vue?vue&type=script&lang=js"
import style0 from "./agePieChart.vue?vue&type=style&index=0&id=2e269bfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e269bfb",
  null
  
)

export default component.exports